module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic_1.4a921b39.ttf";